// Return destinations are application paths, unlike notification resources,
// which can intentionally link to external web sites. Preserve the supplied
// path (including encoded identifiers) rather than decoding it for navigation.
const hasUnsafeCharacters = (value: string, includeSpace: boolean): boolean =>
  value.includes('\\') || Array.from(value).some(character => {
    const code = character.charCodeAt(0);
    return code <= (includeSpace ? 32 : 31) || code === 127;
  });

export const internalNavigationDestination = (value: unknown, fallback = '/home'): string => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') ||
      hasUnsafeCharacters(value, true)) return fallback;
  try {
    const decoded = decodeURIComponent(value);
    if (!decoded.startsWith('/') || decoded.startsWith('//') || hasUnsafeCharacters(decoded, false)) return fallback;
    return value;
  } catch {
    return fallback;
  }
};

// The forced password change is an account gate that ProtectedRoute routes to
// on its own. Returning to it after sign-in or after completing the change
// would repeat a finished step, so it is never a return destination.
const completedAccountGatePaths = new Set(['/change-password']);

export const postAuthenticationDestination = (value: unknown, fallback = '/home'): string => {
  const destination = internalNavigationDestination(value, fallback);
  const pathname = decodeURIComponent(destination.split(/[?#]/)[0]).replace(/\/+$/, '').toLowerCase();
  return completedAccountGatePaths.has(pathname) ? fallback : destination;
};
